import type {
  OrganizationEntityConfiguration,
  OrganizationStroomConfiguration,
} from '@/types/organization-config'

export function getStroomConfig(
  configs: OrganizationEntityConfiguration[]
): OrganizationStroomConfiguration | undefined {
  const config = configs.find(param => param.entity === 'Stroom')
  if (!isStroomConfig(config)) return undefined
  return config
}

export function isStroomConfig(
  config: OrganizationEntityConfiguration | undefined
): config is OrganizationStroomConfiguration {
  return config?.entity === 'Stroom'
}
